import { Observable, take } from 'rxjs';
import { PaginatedContent } from '../../../api/common.types';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { AccountFilter } from '../home-admin-data/account.types';

export class TableStateManager<TItem, TFilter extends AccountFilter = AccountFilter> {
  loading = true;
  preventDoubleFetch = true;
  lastSort: Array<{ key: string; value: string | null }> = [];
  lastFetchStr = '';
  data?: PaginatedContent<TItem>;

  constructor(
    private fetchFn: (filter: TFilter) => Observable<PaginatedContent<TItem>>,
    private onNext?: (response: PaginatedContent<TItem>) => void
  ) {}

  fetchData(filter: TFilter): void {
    this.loading = true;
    let tempItems: TItem[] = [];

    if (this.data && this.data.items) {
      tempItems = [...this.data.items];
      this.data.items = [];
    }

    this.fetchFn(filter)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          if (this.onNext) {
            this.onNext(response);
          }
          this.data = response;
          this.loading = false;
        },
        error: () => {
          if (this.data) {
            this.data.items = tempItems;
          }
          this.loading = false;
        },
      });
  }

  onPageChange(pageIndex: number, buildFilterFn: () => Partial<TFilter>): void {
    const pageSize = this.data?.paging?.itemsOnPage || 10;
    this.onQueryParamsChange({
      pageIndex,
      pageSize,
      sort: this.lastSort,
      filter: []
    }, buildFilterFn);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onQueryParamsChange(params: NzTableQueryParams, buildFilterFn: () => Partial<TFilter>): void {
    this.lastSort = params.sort;
    if (this.loading) return;
    if (this.preventDoubleFetch) {
      this.preventDoubleFetch = false;
      return;
    }
    const { pageSize, pageIndex, sort } = params;

    const currentSort = sort.find((item) => item.value !== null);
    const sortField = (currentSort && currentSort.key) || null;
    const sortOrder = (currentSort && currentSort.value) || null;

    let change: any = {
      paging: {
        page: pageIndex,
        itemsOnPage: pageSize,
      },
      ...buildFilterFn(),
    };

    if (sortField && sortOrder) {
      change = {
        ...change,
        sort: [
          {
            order: sortOrder === 'ascend' ? 'ASC' : 'DESC',
            field: sortField,
          },
        ],
      };
    }

    this.onQueryChange(change as TFilter);
  }

  onQueryChange(filter: TFilter): void {
    const fetchStr = JSON.stringify(filter);
    if (this.lastFetchStr === fetchStr) {
      return;
    }
    this.lastFetchStr = fetchStr;
    this.fetchData(filter);
  }
}
